import autoAnimate, { getTransitionSizes } from '@formkit/auto-animate';

export class AutoAnimate {

    constructor ( target = '.js-auto-animate', options = {} ) {
        this.target = target;

        this.options = {
            ...options
        }
    }

    init () {
        this.$containers = document.querySelectorAll(this.target);

        this.$containers.forEach( $container => {
            autoAnimate($container);
        })
    }

}
